import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'

import {
  IJBPActualsAndTargetsCategoriesCrudParams,
  IJBPActualsAndTargetsCategory,
} from '../models/jbpActualsAndTargetsCategories'

export const getJBPActualsAndTargetsCategoriesCrud = ({
  programType,
  fYear,
}: IJBPActualsAndTargetsCategoriesCrudParams): Crud<IJBPActualsAndTargetsCategory> => {
  const crud = CrudStore.get(
    CrudStoreItemPartner360.JBPActualsAndTargetsCategories,
    'businessUnits'
  ) as Crud<IJBPActualsAndTargetsCategory>

  crud.setSort({
    field: 'CategoryOrder',
    dir: 'asc',
  })

  crud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'programType',
        operator: Operator.EQUAL,
        value: programType,
      },
      { field: 'FYear', operator: Operator.EQUAL, value: fYear },
    ],
  })

  return crud
}
